import React, { useMemo } from 'react';
import { Button } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { unparse } from 'papaparse';

const buildDownloadMatrix = (columns = [], rows = [], pinnedRows = []) => {
  if (!columns.length || (!rows.length && !pinnedRows.length)) {
    return null;
  }

  const headers = columns.map((col) => col.headerName ?? col.field ?? "");
  const formatRow = (row) =>
    columns.map((col) => {
      const value = row?.[col.field];
      return value === null || value === undefined ? "" : value;
    });

  const normalizedRows = rows.map(formatRow);
  const normalizedPinnedRows = pinnedRows.map(formatRow);

  return [headers, ...normalizedRows, ...normalizedPinnedRows];
};

const TableDownloadData = ({
  columnDefs = [],
  rowData = [],
  pinnedBottomRowData = [],
}) => {
  const safeColumns = Array.isArray(columnDefs) ? columnDefs : [];
  const safeRows = Array.isArray(rowData) ? rowData : [];
  const safePinnedRows = Array.isArray(pinnedBottomRowData)
    ? pinnedBottomRowData
    : [];

  const downloadMatrix = useMemo(
    () => buildDownloadMatrix(safeColumns, safeRows, safePinnedRows),
    [safeColumns, safeRows, safePinnedRows]
  );

  const hasDownloadableData = !!downloadMatrix;

  const handleDownload = () => {
    if (!downloadMatrix) {
      return;
    }

    const csv = unparse(downloadMatrix);
    const blob = new Blob([csv], {
      type: "text/csv;charset=utf-8;",
    });

    const timestampSuffix = new Date().toISOString().replace(/[:.]/g, "-");
    const fileName = `table-data-${timestampSuffix}.csv`;

    const navigatorObj =
      typeof navigator !== "undefined" ? navigator : undefined;

    if (navigatorObj?.msSaveOrOpenBlob) {
      navigatorObj.msSaveOrOpenBlob(blob, fileName);
      return;
    }

    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.style.display = "none";
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setTimeout(() => URL.revokeObjectURL(url), 0);
  };


    return (
      <div style={
        {
          display: "flex",
          justifyContent: "right",
          alignItems: "flex-end",
          width: "100%",
          height: "0.2vh",
          zIndex: 1,
          marginTop: "1.25em",
          marginLeft: "0.0vw",
        }
      }>
        <Button style={{
          alignItems: "center",
          justifyContent: "center",
          height: "1.5em",
          width: "1.5em",
          borderRadius: "128px",
          fontSize: "1em",
        }} type="primary" disabled={!hasDownloadableData} onClick={handleDownload}><DownloadOutlined /></Button>
      </div>
    );
};

export default TableDownloadData;

